import React from "react";
import { Link } from "react-router-dom";
import "../css/Hero.css";
import me from "../assets/me-work.png";

export default function Hero({ onDownloadCv }) {
  return (

    <section className="hero" id="hero">
      <div className="heroInner heroSplit">
        <div className="heroContent">
          <p className="heroKicker">hi, i’m hamza</p>

          <h1 className="heroTitle">
            I help product teams ship, stabilize, and modernize web applications.
          </h1>

          <p className="heroSub">
            Freelance software lead engineer focused on PHP / Symfony / Laravel · React · APIs · legacy modernization · production support
          </p>

          <div className="heroSignals" aria-label="Professional focus">
            <span>Freelance delivery</span>
            <span>L2/L3 support</span>
            <span>Production releases</span>
          </div>

          <div className="heroActions">
            <button className="heroBtn heroBtnPrimary" type="button" onClick={onDownloadCv}>
              Download CV
            </button>
            <Link className="heroBtn" to="/enterprise">
              Enterprise work
            </Link>
          </div>
        </div>

        <div className="heroVisual">
          <img src={me} alt="Hamza portrait" loading="lazy" />
        </div>
      </div>
    </section>
  );
}
